import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
	providedIn: 'root',
})
export class StockCountService {
	private getQtdsTotalCmdb = environment.baseApiUrl + 'stock/searchQtd';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	getTotalQtds(idCi: string): Observable<any> {
		const getQtdsUrl = `${this.getQtdsTotalCmdb}?cmdb_id=${idCi}`;
		return this.http.get<any[]>(getQtdsUrl, { headers: this.headers });
	}
}
